var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixEventsV1TicketDefinition from '@wix/ambassador-events-v1-ticket-definition/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var FeeType;
(function (FeeType) {
    /** Fee is added to the ticket price at checkout */
    FeeType["FEE_ADDED"] = "FEE_ADDED";
    /** Seller absorbs the fee. It is deducted from the ticket price */
    FeeType["FEE_INCLUDED"] = "FEE_INCLUDED";
    /** Fee is added to the ticket price at checkout */
    FeeType["FEE_ADDED_AT_CHECKOUT"] = "FEE_ADDED_AT_CHECKOUT";
})(FeeType || (FeeType = {}));
export var TicketSaleStatus;
(function (TicketSaleStatus) {
    /** Ticket sale is scheduled to start */
    TicketSaleStatus["SALE_SCHEDULED"] = "SALE_SCHEDULED";
    /** Ticket sale has started */
    TicketSaleStatus["SALE_STARTED"] = "SALE_STARTED";
    /** Ticket sale has ended */
    TicketSaleStatus["SALE_ENDED"] = "SALE_ENDED";
})(TicketSaleStatus || (TicketSaleStatus = {}));
export var TicketDefinitionStateEnumState;
(function (TicketDefinitionStateEnumState) {
    TicketDefinitionStateEnumState["INCLUDE_HIDDEN_NOT_ON_SALE"] = "INCLUDE_HIDDEN_NOT_ON_SALE";
})(TicketDefinitionStateEnumState || (TicketDefinitionStateEnumState = {}));
export var Type;
(function (Type) {
    Type["STANDARD"] = "STANDARD";
    Type["DONATION"] = "DONATION";
})(Type || (Type = {}));
export var TicketDefinitionFieldset;
(function (TicketDefinitionFieldset) {
    /** Include policy in the response. */
    TicketDefinitionFieldset["POLICY"] = "POLICY";
    /** Include dashboard in the response. */
    TicketDefinitionFieldset["DASHBOARD"] = "DASHBOARD";
})(TicketDefinitionFieldset || (TicketDefinitionFieldset = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var State;
(function (State) {
    /** Ticket is available for purchase. */
    State["VISIBLE"] = "VISIBLE";
    /** Opposite to VISIBLE. */
    State["HIDDEN"] = "HIDDEN";
    /** Ticket price is 0. */
    State["FREE"] = "FREE";
    /** Ticket price is greater than 0. */
    State["PAID"] = "PAID";
})(State || (State = {}));
export var GroupBy;
(function (GroupBy) {
    /** No grouping. */
    GroupBy["NONE"] = "NONE";
    /** Groups by event created date with descending sorting. */
    GroupBy["EVENT_CREATED_DESC"] = "EVENT_CREATED_DESC";
    /** Groups by event created date with ascending sorting. */
    GroupBy["EVENT_CREATED_ASC"] = "EVENT_CREATED_ASC";
})(GroupBy || (GroupBy = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _changeCurrencyRequest = {};
const _changeCurrencyResponse = {};
const _createTicketDefinitionRequest = {};
const _createTicketDefinitionResponse = {};
const _deleteTicketDefinitionRequest = {};
const _deleteTicketDefinitionResponse = {};
const _getTicketDefinitionRequest = {};
const _getTicketDefinitionResponse = {};
const _listTicketDefinitionsRequest = {};
const _listTicketDefinitionsResponse = {};
const _queryTicketDefinitionsRequest = {};
const _queryTicketDefinitionsResponse = {};
const _queryTicketDefinitionsV2Request = {};
const _queryTicketDefinitionsV2Response = {};
const _updateTicketDefinitionRequest = {};
const _updateTicketDefinitionResponse = {};
/**
 * **Deprecated.** This function will continue to work until November 8, 2024, but a newer version is available. Use [`queryTicketDefinitions()`](/ticket-definitions-v2/query-ticket-definitions) function instead.
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`queryTicketDefinition()`](/ticket-definitions-v2/query-ticket-definitions).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.queryTicketDefinition()`, and replace it with `ticketDefinitionsV2.queryTicketDefinition()`. Update your code to work with the new `createTicketDefinition()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 * Retrieves a list of up to 100 ticket definitions.
 * @public
 * @adminMethod
 */
export function queryTicketDefinitions(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            offset: '$[0].offset',
            limit: '$[0].limit',
            fieldset: '$[0].fieldset',
            filter: '$[0].filter',
            sort: '$[0].sort',
            facet: '$[0].facet',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _queryTicketDefinitionsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _queryTicketDefinitionsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#definitions']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEventsV1TicketDefinition.queryTicketDefinitions(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * **Deprecated.** This function will continue to work until October 29, 2024, but a newer version is available at [`queryTicketDefinitions()`](/ticket-definitions-v2/query-ticket-definitions).
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`queryTicketDefinitions()`](/ticket-definitions-v2/query-ticket-definitions).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.queryTicketDefinitions()`, and replace it with `ticketDefinitionsV2.queryTicketDefinitions()`. Update your code to work with the new `queryTicketDefinition()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 * Retrieves a list of up to 1,000 ticket definitions, given the provided paging and filtering.
 * @public
 * @permissionId WIX_EVENTS.READ_TICKET_DEFINITIONS
 * @adminMethod
 */
export function queryTicketDefinitionsV2(options) {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.definitions',
        pagingMetadata: '$.metadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[1];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryTicketDefinitionsV2Request,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryTicketDefinitionsV2Response,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#definitions']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixEventsV1TicketDefinition.queryTicketDefinitionsV2(Object.assign(Object.assign({}, payload), (options !== null && options !== void 0 ? options : {})));
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * **Deprecated.** This function will continue to work until November 8, 2024, but a substitute is available. Use the [`queryTicketDefinitions()`](/ticket-definitions-v2/query-ticket-definitions) function instead.
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`queryTicketDefinitions()`](/ticket-definitions-v2/query-ticket-definitions).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.queryTicketDefinitions()`, and replace it with `ticketDefinitionsV2.queryTicketDefinitions()`. Update your code to work with the new `queryTicketDefinition()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 * Retrieves a list of up to 100 ticket definitions, with basic filter support.
 * @public
 * @param options - Details for the tickets to retrieve.
 * @adminMethod
 */
export function listTicketDefinitions(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0].eventId',
            offset: '$[0].offset',
            limit: '$[0].limit',
            fieldset: '$[0].fieldset',
            eventCreatorId: '$[0].eventCreatorId',
            state: '$[0].state',
            sort: '$[0].sort',
            saleStatus: '$[0].saleStatus',
            facet: '$[0].facet',
            visibleForCoupons: '$[0].visibleForCoupons',
            groupBy: '$[0].groupBy',
            id: '$[0]._id',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listTicketDefinitionsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listTicketDefinitionsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#definitions']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEventsV1TicketDefinition.listTicketDefinitions(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * **Deprecated.** This function will continue to work until November 8, 2024, but a newer version is available. Use the [`getTicketDefinition()`](/ticket-definitions-v2/get-ticket-definition) function instead.
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`getTicketDefinition()`](/ticket-definitions-v2/get-ticket-definition).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.getTicketDefinition()`, and replace it with `ticketDefinitionsV2.getTicketDefinition()`. Update your code to work with the new `getTicketDefinition()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 * Retrieves a ticket definition.
 * @param definitionId - Ticket definition ID.
 * @public
 * @requiredField definitionId
 * @param options - Details for the ticket to retrieve.
 * @adminMethod
 * @returns Retrieved ticket definition.
 */
export function getTicketDefinition(definitionId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            definitionId: '$[0]',
            fieldset: '$[1].fieldset',
        };
        const responseTransformation = '$.definition';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getTicketDefinitionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getTicketDefinitionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['definition']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([definitionId, options]);
        const reqOpts = ambassadorWixEventsV1TicketDefinition.getTicketDefinition(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'definitionId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * **Deprecated.** This function will continue to work until November 8, 2024, but a newer version is available. Use the [`createTicketDefinition()`](/ticket-definitions-v2/create-ticket-definition) function instead.
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`createTicketDefinition()`](/ticket-definitions-v2/create-ticket-definition).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.createTicketDefinition()`, and replace it with `ticketDefinitionsV2.createTicketDefinition()`. Update your code to work with the new `createTicketDefinition()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 * Creates a ticket definition (and enables ticket sales).
 * @param eventId - Event ID.
 * @public
 * @requiredField eventId
 * @requiredField options
 * @requiredField options.definition
 * @requiredField options.definition.name
 * @adminMethod
 */
export function createTicketDefinition(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            definition: '$[1].definition',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createTicketDefinitionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createTicketDefinitionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['definition']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV1TicketDefinition.createTicketDefinition(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * **Deprecated.** This function will continue to work until November 8, 2024, but a newer version is available. Use the [`updateTicketDefinition()`](/ticket-definitions-v2/update-ticket-definition) function instead.
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`updateTicketDefinition()`](/ticket-definitions-v2/update-ticket-definition).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.updateTicketDefinition()`, and replace it with `ticketDefinitionsV2.updateTicketDefinition()`. Update your code to work with the new `updateTicketDefinition()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 *
 * Updates a ticket definition.
 *
 * See [Partial Updates](/wix-events-v2/partial-updates) for more information.
 * @param definitionId - Ticket definition ID.
 * @param eventId - Event ID.
 * @public
 * @requiredField definitionId
 * @requiredField eventId
 * @requiredField options.definition.pricing
 * @param identifiers - Details of the ticket definition to update.
 * @param options - Ticket definition details to update.
 * @adminMethod
 */
export function updateTicketDefinition(definitionId, eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            definitionId: '$[0]',
            eventId: '$[1]',
            definition: '$[2].definition',
            fields: '$[2].fields',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateTicketDefinitionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateTicketDefinitionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['definition']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([definitionId, eventId, options]);
        const reqOpts = ambassadorWixEventsV1TicketDefinition.updateTicketDefinition(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'definitionId',
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * **Deprecated.** This function will continue to work until November 8, 2024, but a newer version is available. Use the [`deleteTicketDefinition()`](/ticket-definitions-v2/delete-ticket-definition) function instead.
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`deleteTicketDefinition()`](/ticket-definitions-v2/delete-ticket-definition).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.deleteTicketDefinition()`, and replace it with `ticketDefinitionsV2.deleteTicketDefinition()`. Update your code to work with the new `deleteTicketDefinition()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 * Deletes a ticket definition.
 * @param eventId - Event ID.
 * @public
 * @requiredField eventId
 * @param options - Details of tickets to delete.
 * @adminMethod
 */
export function deleteTicketDefinition(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            byId: '$[1].byId',
            all: '$[1].all',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteTicketDefinitionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteTicketDefinitionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV1TicketDefinition.deleteTicketDefinition(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * **Deprecated.** This function will continue to work until November 8, 2024, but a newer version is available at [`changeCurrency()`](/ticket-definitions-v2/change-currency).
 * >**Migration Instructions**.
 * > If this function is already in your code, it will continue to work. To stay compatible with future changes, migrate to [`changeCurrency()`](/ticket-definitions-v2/change-currency).
 * > To migrate to the new function:
 * > 1. Add the new import statement:
 * > ```js
 * > import { ticketDefinitionsV2 } from 'wix-events.v2';
 * > ```
 * > 2. Look for any code that uses `ticketDefinitions.changeCurrency()`, and replace it with `ticketDefinitionsV2.changeCurrency()`. Update your code to work with the new `changeCurrency()` response properties.
 * > 3. Test your changes to make sure your code behaves as expected.
 *
 * Changes the currency for all tickets per event.
 *
 * @public
 * @requiredField options.currency
 * @adminMethod
 */
export function changeCurrency(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0].eventId',
            currency: '$[0].currency',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _changeCurrencyRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _changeCurrencyResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEventsV1TicketDefinition.changeCurrency(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=events-v1-ticket-definition.universal.js.map